export default __webpack_public_path__ + "static/pomosty-befe995197a365df284dcb22cfcca38c.jpg";